document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelectorAll('#submenu-sticky-animated__list ol li').length === 0) {
    document.querySelector('.submenu-sticky-animated').classList.add('d-none-element');
  }
  new SubmenuStickyAnimated();
});

class SubmenuStickyAnimated {
  constructor() {
    this.initProperties();
    this.setupEventListeners();
  }

  initProperties() {
    this.$sectionParent = document.querySelector('.nec-sticky-menu');
    this.$sectionToFix = document.querySelector('.submenu-sticky-animated .js-sticky-content');
    this.$container = document.querySelector('.submenu-sticky-animated');
    this.$mainContainer = document.querySelector('#MainContent');
    this.distanceToBottom = this.$mainContainer.offsetTop + this.$mainContainer.offsetHeight;
    this.originalPosition = this.$sectionToFix.offsetTop;
    this.$announcementBar = document.querySelector('#shopify-section-announcement-bar');
    this.$header = document.querySelector('#shopify-section-header-v2');
    this.currentScrollTop = 0;

    this.headerGroupHeight = this.calculateHeaderGroupHeight();
    this.newOriginalPosition = this.originalPosition - this.headerGroupHeight;

    this.sections = document.querySelectorAll('.nec-sticky-menu-section .nec-sticky-menu-target');
    this.myMediaQuery = window.matchMedia('(min-width: 768px)');
    this.tocLi = document.querySelectorAll('#submenu-sticky-animated__list ol li');
  }

  calculateHeaderGroupHeight() {
    if (this.$announcementBar) {
      return this.$announcementBar.offsetHeight + this.$header.offsetHeight;
    } else {
      return this.$header.offsetHeight;
    }
  }

  setupEventListeners() {
    window.addEventListener('resize', this.menuScroll.bind(this));
    window.addEventListener('scroll', this.scrollEvent.bind(this));

    this.tocLi.forEach((li) => {
      const url = li.children[0].href;
      const hashIndex = url.indexOf('#');
      const liClass = url.substring(hashIndex + 1);
      if (liClass) li.classList.add(liClass);
    });
  }

  menuScroll() {
    document.querySelectorAll('#submenu-sticky-animated__list ol li a').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        var offset = this.headerGroupHeight;
        var target = document.getElementById(link.getAttribute('data-section'));

        var scrollTopOffset = this.myMediaQuery.matches
          ? -offset - document.querySelector('.submenu-sticky-animated').offsetHeight
          : -offset - document.querySelector('#submenu-sticky-animated__list').offsetHeight;

        if (!this.myMediaQuery.matches) {
          document.querySelector('.js-toggle-sidebar-navigation')?.dispatchEvent(new Event('click'));
        }

        window.scroll({
          top: target.offsetTop + scrollTopOffset,
          behavior: 'smooth',
        });
      });
    });

    this.tocLi.forEach((li) => {
      var url = li.children[0].href;
      var hashIndex = url.indexOf('#');
      var liClass = url.substring(hashIndex + 1);
      if (liClass) li.classList.add(liClass);
    });

    var sectionLinks = document.querySelectorAll('#submenu-sticky-animated__list ol li a');
    sectionLinks.forEach((section, i) => {
      var url = section.getAttribute('href');
      var hashIndex = url.indexOf('#');
      var aHref = url.substring(hashIndex + 1);
      if (aHref) section.setAttribute('data-section', aHref);
    });

    /* In the provided JavaScript code, `this.stickyMainElm` is being assigned the value of the element
    with the class name `.submenu-sticky-animated`. This element is being selected using
    `document.querySelector('.submenu-sticky-animated')` and stored in the `this.stickyMainElm`
    property of the `SubmenuStickyAnimated` class instance. */
    this.stickyMainElm = document.querySelector('.submenu-sticky-animated');
    this.$sectionToFix = document.querySelector('.submenu-sticky-animated .js-sticky-content');

    this.$container = document.querySelector('.submenu-sticky-animated');
    this.$mainContainer = document.querySelector('#MainContent');
    this.distanceToBottom = this.$mainContainer.offsetTop + this.$mainContainer.offsetHeight;
    this.originalPosition = this.stickyMainElm.offsetTop;
    this.$announcementBar = document.querySelector('#shopify-section-announcement-bar');
    this.$header = document.querySelector('#shopify-section-header-v2');

    if (this.$announcementBar) {
      this.headerGroupHeight = this.$announcementBar.offsetHeight + this.$header.offsetHeight;
    } else {
      this.headerGroupHeight = this.$header.offsetHeight;
    }

    this.newOriginalPosition = this.originalPosition - this.headerGroupHeight;

    const debouncedFB = this.debounce(this.scrollEvent.bind(this), 1500);
    window.removeEventListener('scroll', this.scrollEvent.bind(this));
    window.addEventListener('scroll', debouncedFB);
  }

  scrollEvent() {
    var scrollTop = window.scrollY;

    if (this.$sectionToFix.classList.contains('js-submenu-horizontal-style--shy')) {
      if (scrollTop >= this.newOriginalPosition && scrollTop <= this.distanceToBottom) {
        this.$sectionToFix.classList.add('js-submenu-fixed--shy');
        this.$sectionParent.style.top = this.headerGroupHeight + 'px';

        if (scrollTop < this.currentScrollTop) {
          this.$sectionParent.classList.add('animate');
        } else if(scrollTop > this.currentScrollTop) {
          this.$sectionParent.classList.remove('animate');
        }

        this.currentScrollTop = scrollTop;
      } else {
        this.$sectionToFix.classList.remove('js-submenu-fixed--shy');
        this.$sectionParent.classList.remove('animate');
        this.$sectionParent.style.top = 0 + 'px';
      }
    } else {
      if (scrollTop >= this.newOriginalPosition && scrollTop <= this.distanceToBottom) {
        this.$sectionToFix.classList.add('js-submenu-fixed');

        if (this.$sectionToFix.classList.contains('js-submenu-fixed-top')) {
          this.$sectionToFix.style.top = this.headerGroupHeight + 'px';
        }

        this.$container.style.height = this.$sectionToFix.offsetHeight + 'px';
      } else {
        this.$sectionToFix.classList.remove('js-submenu-fixed');
        this.$container.style.height = 'auto';

        if (this.$sectionToFix.classList.contains('js-submenu-fixed-top')) {
          this.$sectionToFix.style.top = 0 + 'px';
        }
      }

      if (scrollTop >= this.newOriginalPosition) {
        document.querySelector('.submenu-sticky-animated').classList.add('overflow-hidden');
      } else {
        document.querySelector('.submenu-sticky-animated').classList.remove('overflow-hidden');
      }
    }

    let current = '';
    this.sections.forEach((section) => {
      var sectionTop = !this.myMediaQuery.matches
        ? section.offsetTop - this.headerGroupHeight - document.querySelector('#submenu-sticky-animated__list').offsetHeight
        : section.offsetTop - this.headerGroupHeight - document.querySelector('.submenu-sticky-animated').offsetHeight;
      if (scrollTop >= sectionTop) {
        current = section.id;
      }
    });

    this.tocLi.forEach((li) => {
      li.classList.remove('active');
      if (li.classList.contains(current)) {
        li.classList.add('active');
        var activeSubNav = document.querySelector('.submenu-toggle__name');
        if (activeSubNav) {
          activeSubNav.innerHTML = li.querySelector('a').getAttribute('data-nav-text');
        }
        const submenuMobileHeader = document.querySelector('.js-submenu-horizontal-style--mobile .page-width__header');
      }
    });
    this.submenuInScreen();
  }

  debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  submenuInScreen() {
    // menu scroll
    if (window.innerWidth < 1024) {
      if( document.getElementsByClassName('nav-scroller').length > 0 )
      {
        let navScroller = document.getElementsByClassName('nav-scroller');
        navScroller[0].scrollLeft = 0;
          var menus = document.getElementsByClassName('nav-menu__item');
          for (var i = 0; i < menus.length; i++) {
              if (menus[i].classList.contains('active')) {
                  document.getElementsByClassName('nav-scroller')[0].scrollLeft = menus[i].offsetLeft;
              }
          }
      }
    }
  }

}

document.addEventListener('DOMContentLoaded', function () {
  // mobile menu slide toggle sidebar blog
  document.querySelector('.js-toggle-sidebar-navigation')?.addEventListener('click', function () {
    this.classList.toggle('is-active');
  });

  document.querySelector('.js-toggle-sidebar-navigation-simulator')?.addEventListener('click', function () {
    document.querySelector('.js-toggle-sidebar-navigation').dispatchEvent(new Event('click'));
  });
});
